import styles from "./funLoading.module.scss";
interface FunLoadingProps {
  size: number;
}
export default function FunLoading({ size }: FunLoadingProps) {
  return (
    <div className={styles.spinner} style={{ width: size, height: size }}>
      <div className={styles["spinner-inner"]} />
    </div>
  );
}
